import { StyleSheet } from 'react-native';

import { colors, spacing } from '@pletly/ui';
import { FriendsAndInvites } from './users/FriendsAndInvites';

const MyConnections = () => {
	return (
		<FriendsAndInvites style={styles.listContainer} contentContainerStyle={styles.listContent} />
	);
};

const styles = StyleSheet.create({
	listContainer: {
		flexDirection: 'row',
		backgroundColor: colors.white,
		borderRadius: spacing(),
		marginVertical: spacing(4),
		paddingTop: spacing(),
	},
	listContent: {
		padding: spacing(4),
	},
});

export default MyConnections;
